var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _c("h3", [_vm._v("短信服务核心配置")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("div", { staticClass: "frb" }, [
            _c("h3", [_vm._v("阿里云短信服务配置")]),
            _vm._v(" "),
            _c("div", { staticClass: "fc" }, [
              _vm.inUse !== "ali"
                ? _c(
                    "div",
                    {
                      staticClass: "fc pointer",
                      staticStyle: {
                        width: "170px",
                        height: "32px",
                        border: "1px #67C23A solid",
                        "border-radius": "4px",
                        color: "#67C23A",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSetDefault("ali")
                        },
                      },
                    },
                    [_vm._v("设为默认服务商")]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "fc pointer",
                      staticStyle: {
                        width: "170px",
                        height: "32px",
                        background: "#67C23A",
                        border: "1px #67C23A solid",
                        "border-radius": "4px",
                        color: "#fff",
                      },
                    },
                    [_vm._v("当前默认")]
                  ),
            ]),
          ]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "220px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "阿里 AccessKey ID：",
                        prop: "aliAccessKey",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm.aliAccessKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "aliAccessKey", $$v)
                          },
                          expression: "ruleForm.aliAccessKey",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "阿里 AccessKey Secret ID：", prop: "" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm.aliAccessSecret,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "aliAccessSecret", $$v)
                          },
                          expression: "ruleForm.aliAccessSecret",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "阿里 EndPoint:", prop: "copyright" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm.aliEndPoint,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "aliEndPoint", $$v)
                          },
                          expression: "ruleForm.aliEndPoint",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "阿里签名：", prop: "smsName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm.smsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "smsName", $$v)
                          },
                          expression: "ruleForm.smsName",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("需先从阿里云创建并通过审核"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "阿里验证码 模板CODE", prop: "smsCode" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm.smsCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "smsCode", $$v)
                          },
                          expression: "ruleForm.smsCode",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("需先从阿里云创建并通过审核"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "模板内容", prop: "copyright" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: {
                          placeholder: "请输入",
                          clearable: "",
                          rows: 4,
                          type: "textarea",
                        },
                        model: {
                          value: _vm.ruleForm.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "content", $$v)
                          },
                          expression: "ruleForm.content",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt20" },
        [
          _c("div", { staticClass: "frb" }, [
            _c("h3", [_vm._v("UMC短信服务配置")]),
            _vm._v(" "),
            _c("div", { staticClass: "fc" }, [
              _vm.inUse !== "ali"
                ? _c(
                    "div",
                    {
                      staticClass: "fc pointer",
                      staticStyle: {
                        width: "170px",
                        height: "32px",
                        background: "#67C23A",
                        border: "1px #67C23A solid",
                        "border-radius": "4px",
                        color: "#fff",
                      },
                    },
                    [_vm._v("当前默认")]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "fc pointer",
                      staticStyle: {
                        width: "170px",
                        height: "32px",
                        border: "1px #67C23A solid",
                        "border-radius": "4px",
                        color: "#67C23A",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSetDefault("umc")
                        },
                      },
                    },
                    [_vm._v("设为默认服务商")]
                  ),
            ]),
          ]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm1",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.ruleForm1,
                    rules: _vm.rules1,
                    "label-width": "220px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Account ID:", prop: "accountId" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm1.accountId,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm1, "accountId", $$v)
                          },
                          expression: "ruleForm1.accountId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Password:", prop: "password" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm1.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm1, "password", $$v)
                          },
                          expression: "ruleForm1.password",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Product ID", prop: "productId" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm1.productId,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm1, "productId", $$v)
                          },
                          expression: "ruleForm1.productId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "签名", prop: "smsName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.ruleForm1.smsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm1, "smsName", $$v)
                          },
                          expression: "ruleForm1.smsName",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("需先从UMC创建并通过审核"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "模板内容:", prop: "content" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: {
                          placeholder: "请输入",
                          rows: 4,
                          type: "textarea",
                          clearable: "",
                        },
                        model: {
                          value: _vm.ruleForm1.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm1, "content", $$v)
                          },
                          expression: "ruleForm1.content",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm1("ruleForm1")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }